import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  row: {
    padding: theme.spacing(5, 8, 4)
  },
  billingDetailsContainer: {
    margin: 'unset'
  },
  bankAccounts: {
    width: '100%',
    margin: theme.spacing(2, 0, 2, 0.5)
  },
  separator: {
    width: 1,
    height: 28,
    margin: theme.spacing('auto', 2),
    backgroundColor: theme.colorPalette.white_op_30
  },
  checkImage: {
    width: 72,
    height: 36
  },
  addCardImage: {
    marginRight: theme.spacing(1)
  },
  addCardButton: {
    width: 208,
    padding: theme.spacing(2, 4),
    marginLeft: theme.spacing(2)
  },
  directBillingDescription: {
    fontSize: 10,
    fontWeight: 400,
    color: theme.colorPalette.white,
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(2)
  }
});

export default makeStyles(styles);
